import type { ReactNode } from 'react'
import { Icon, type IconName } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

export type BadgeTone = 'neutral' | 'brand' | 'success' | 'warning' | 'error' | 'info'

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'border-border bg-surface-muted text-ink-secondary',
  brand: 'border-border-brand bg-accent-surface text-accent-text',
  success: 'border-border-brand bg-success-surface text-success-strong',
  warning: 'border-warning/40 bg-warning-surface text-warning-strong',
  error: 'border-error/40 bg-error-surface text-error-strong',
  info: 'border-info/30 bg-info-surface text-info-strong',
}

type BadgeProps = {
  tone?: BadgeTone
  icon?: IconName
  children: ReactNode
  className?: string
}

export function Badge({ tone = 'neutral', icon, children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-xs font-medium tracking-wide whitespace-nowrap uppercase',
        toneClasses[tone],
        className,
      )}
    >
      {icon ? <Icon name={icon} className="size-3.5" /> : null}
      {children}
    </span>
  )
}
